<template>
  <div></div>
</template>

<script>
export default {
  name: 'DynamicLink',
  async mounted() {
    function isAndroid() {
      return /Android/.test(window.navigator.userAgent);
    }

    setTimeout(() => {
      const appName = this.$route.params.appName;
      const search = window.location.search;
      const separator = search ? '&' : '?';

      let url = '';
      if (isAndroid()) {
        // appName uses underscore for Android, no conversion
        url = 'com.syn-inc.' + appName + '://chompy.jp' + search + separator + 'type=PAYPAY_PAAS';
      } else {
        let name = appName.replace('_', '-');
        url = 'com.syn-inc.' + name + '://chompy.jp' + search + separator + 'type=PAYPAY_PAAS';
      }
      window.location = url;
    }, 1000);
  }
};
</script>
